// src/pages/Landing.js

import React from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import WhyChooseUs from '../components/landing/WhyChooseUs'; // Import the new section
import TeamSection from '../components/landing/TeamSection';
import Footer from '../components/landing/Footer';
import { Box } from '@mui/material';
import MissionVisionValues from '../components/MissionVisionValues';

const Landing = () => {
    return (
        <Box>
            <Header />
            <main>
                <HeroSection />
                <WhyChooseUs />
                <TeamSection />
                <MissionVisionValues />
            </main>
            <Footer />
        </Box>
    );
};

export default Landing;